import { render } from "./PartData.vue?vue&type=template&id=6d759d72&scoped=true"
import script from "./PartData.vue?vue&type=script&lang=js"
export * from "./PartData.vue?vue&type=script&lang=js"

import "./PartData.vue?vue&type=style&index=0&id=6d759d72&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d759d72"]])

export default __exports__